import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/AuthGoogle.graphql';
import { Mutation, MutationauthGoogleArgs } from '../../__generated__/globalTypes';

export const useAuthGoogleMutation = (options?: MutationHookOptions<Mutation, MutationauthGoogleArgs>) => {
  const [callAuthGoogle, result] = useMutation<Mutation, MutationauthGoogleArgs>(MUTATION, options);

  return { callAuthGoogle, ...result };
};

export type AuthGoogleMutationFunction = Mutation['authGoogle'];
